module.exports = __webpack_public_path__ + "static/media/home-backhoe-loaders.9a623f36.jpg";